import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const ClickHandler = () => window.scrollTo({ top: 0, behavior: "smooth" });

const Footer = (props) => {
  const logo = useSelector((store) => store?.configs?.admin_conditions?.website_logo);
  const emailSupport = useSelector(
    (s) => s?.configs?.admin_conditions?.email_support || "support@globalgiftpass.io"
  );
  const mobileSupport = useSelector(
    (s) => s?.configs?.admin_conditions?.mobile_support || "+971 545740174"
  );

  const year = new Date().getFullYear();

  return (
    <footer className="gpft-footer">
      {/* TOP CTA STRIP */}
      <div className="gpft-cta-strip">
        <div className="gpft-cta-inner">
          <div className="gpft-cta-text">
            <div className="gpft-cta-eyebrow">
              <span className="gpft-cta-dot" />
              NEED A HAND?
            </div>
            <h3>
              Get in <span>touch with us</span>
            </h3>
            <p>
              Order question or voucher trouble? Reach us on WhatsApp or email
              and we'll take care of it.
            </p>
          </div>
          <div className="gpft-cta-actions">
            <a
              className="gpft-cta-btn gpft-cta-wa"
              href="https://wa.me/971545740174?text=Hello%20GlobalGiftPass%20support%2C%20I%20need%20help."
              target="_blank"
              rel="noreferrer"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.52 3.48A11.94 11.94 0 0012.06 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.34-1.66a11.85 11.85 0 005.71 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.45z" />
              </svg>
              Chat on WhatsApp
            </a>
            <Link to="/support" onClick={ClickHandler} className="gpft-cta-btn gpft-cta-primary">
              Contact Support
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <div className="gpft-bg-orb gpft-bg-orb-tl" />
      <div className="gpft-bg-orb gpft-bg-orb-br" />

      {/* MAIN GRID */}
      <div className="gpft-main">
        <div className="gpft-grid">
          {/* BRAND */}
          <div className="gpft-brand-col">
            <Link to="/" className="gpft-brand" onClick={ClickHandler}>
              {logo ? (
                <img src={logo} alt="GlobalGiftPass" />
              ) : (
                <span className="gpft-brand-text">
                  <span>GLOBAL</span>GIFT PASS
                </span>
              )}
            </Link>

            <p className="gpft-brand-blurb">
              The luxury digital gift card destination for the UAE. Authorized
              brands and instant delivery, every time.
            </p>

            <div className="gpft-info-list">
              <div className="gpft-info-row">
                <span className="gpft-info-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
                  </svg>
                </span>
                <span>
                  Ventureworks Dynamics LLC<br />
                  Sharjah Media City, Sharjah, UAE
                </span>
              </div>
              <div className="gpft-info-row">
                <span className="gpft-info-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
                  </svg>
                </span>
                <span>Trade License: <strong>243067201</strong></span>
              </div>
              <a className="gpft-info-row gpft-info-link" href={`mailto:${emailSupport}`}>
                <span className="gpft-info-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5z" />
                  </svg>
                </span>
                <span>{emailSupport}</span>
              </a>
              {/* <a
                className="gpft-info-row gpft-info-link"
                href={`https://wa.me/${mobileSupport.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
              >
                <span className="gpft-info-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                  </svg>
                </span>
                <span>{mobileSupport}</span>
              </a> */}
            </div>

            <div className="gpft-trust-row">
           
              <span className="gpft-trust-pill">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z" />
                </svg>
                3D Secure
              </span>
              <span className="gpft-trust-pill">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                Verified
              </span>
            </div>
          </div>

          {/* COMPANY LINKS */}
          <div className="gpft-col">
            <h4 className="gpft-col-title">Company</h4>
            <ul className="gpft-link-list">
              <li><Link to="/about" onClick={ClickHandler}>About Us</Link></li>
              <li><Link to="/why-choose-us" onClick={ClickHandler}>Why Choose Us</Link></li>
              <li><Link to="/supplier-standards" onClick={ClickHandler}>Supplier Standards</Link></li>
              <li><Link to="/corporate-orders" onClick={ClickHandler}>Corporate Orders</Link></li>
               <li><Link to="/how-to-redeem" onClick={ClickHandler}>How to Redeem</Link></li>
              <li><Link to="/redeem" onClick={ClickHandler}>Concierge / Redeem</Link></li>
             
            </ul>
          </div>

          {/* SHOP */}
          <div className="gpft-col">
            <h4 className="gpft-col-title">Shop</h4>
            <ul className="gpft-link-list">
              <li><Link to="/shop" onClick={ClickHandler}>All Gift Cards</Link></li>
              <li><Link to="/cart" onClick={ClickHandler}>Cart</Link></li>
              <li><Link to="/your-orders" onClick={ClickHandler}>My Orders</Link></li>
              <li><Link to="/contact" onClick={ClickHandler}>Contact</Link></li>
            </ul>
          </div>

          {/* LEGAL */}
          <div className="gpft-col">
            <h4 className="gpft-col-title">Legal</h4>
            <ul className="gpft-link-list">
              <li><Link to="/privacy" onClick={ClickHandler}>Privacy Policy</Link></li>
              <li><Link to="/tos" onClick={ClickHandler}>Terms &amp; Conditions</Link></li>
              <li><Link to="/rr" onClick={ClickHandler}>Refund &amp; Return</Link></li>
              <li><Link to="/shipping" onClick={ClickHandler}>Usage Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* DIVIDER + PAYMENT + SOCIAL */}
        <div className="gpft-divider-row">
          <div className="gpft-payments">
            <span className="gpft-payments-label">Accepted Payments</span>
            <div className="gpft-payment-cards">
              <span className="gpft-payment-card gpft-pay-visa">VISA</span>
              <span className="gpft-payment-card gpft-pay-mc">
                <span className="gpft-mc-1" />
                <span className="gpft-mc-2" />
              </span>
              <span className="gpft-payment-card gpft-pay-secure">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z" />
                </svg>
                3D Secure
              </span>
            </div>
          </div>

          <div className="gpft-social">
            <span className="gpft-social-label">Follow Us</span>
            <div className="gpft-social-icons">
              <a
                href="https://www.instagram.com/globalgiftpass/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23a3.7 3.7 0 01-.9 1.38c-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.22.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 01-1.38-.9 3.7 3.7 0 01-.9-1.38c-.16-.42-.36-1.06-.41-2.22-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.22-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.86 5.86 0 00-2.13 1.38A5.86 5.86 0 00.63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91a5.86 5.86 0 001.38 2.13 5.86 5.86 0 002.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.86 5.86 0 002.13-1.38 5.86 5.86 0 001.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.86 5.86 0 00-1.38-2.13A5.86 5.86 0 0019.86.63C19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 005.84 12 6.16 6.16 0 0012 18.16 6.16 6.16 0 0018.16 12 6.16 6.16 0 0012 5.84zm0 10.16A4 4 0 1112 8a4 4 0 010 8zm6.4-11.85a1.44 1.44 0 100 2.88 1.44 1.44 0 000-2.88z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61571792009734"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.408.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.795.143v3.24h-1.918c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.592 1.323-1.325V1.325C24 .593 23.408 0 22.675 0z" />
                </svg>
              </a>
              <a
                href={`https://wa.me/${mobileSupport.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="gpft-social-wa"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.52 3.48A11.94 11.94 0 0012.06 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.34-1.66a11.85 11.85 0 005.71 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.45z" />
                </svg>
              </a>
              <a href={`mailto:${emailSupport}`} aria-label="Email">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="gpft-bottom">
        <div className="gpft-bottom-inner">
          <p className="gpft-copy">
            © {year} <strong>Ventureworks Dynamics LLC</strong>. All rights reserved.
          </p>
          <p className="gpft-made">
            <span className="gpft-flag" aria-hidden="true">🇦🇪</span>
            Crafted in the United Arab Emirates
          </p>
        </div>
      </div>

      <style>{`
        .gpft-footer {
          position: relative;
          background: linear-gradient(180deg, #07060a 0%, #0b0b0c 50%, #050407 100%);
          color: #cfd2d6;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          overflow: hidden;
          border-top: 1px solid rgba(212, 168, 87, 0.18);
        }
        .gpft-bg-orb {
          position: absolute;
          width: 460px; height: 460px;
          border-radius: 50%;
          filter: blur(140px);
          opacity: 0.3;
          pointer-events: none;
        }
        .gpft-bg-orb-tl { background: rgba(212,168,87,0.18); top: -180px; left: -120px; }
        .gpft-bg-orb-br { background: rgba(212,168,87,0.12); bottom: -180px; right: -120px; }

        /* CTA STRIP */
        .gpft-cta-strip {
          position: relative;
          background: linear-gradient(135deg, #15110a 0%, #1a1208 100%);
          border-bottom: 1px solid rgba(212, 168, 87, 0.18);
          overflow: hidden;
        }
        .gpft-cta-strip::before {
          content: "";
          position: absolute;
          top: -100px; right: -100px;
          width: 360px; height: 360px;
          background: radial-gradient(circle, rgba(212,168,87,0.18), transparent 70%);
          pointer-events: none;
        }
        .gpft-cta-inner {
          position: relative;
          max-width: 1200px;
          margin: 0 auto;
          padding: 36px 22px;
          display: grid;
          grid-template-columns: 1fr auto;
          gap: 22px;
          align-items: center;
        }
        .gpft-cta-text { min-width: 0; }
        .gpft-cta-eyebrow {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 5px 12px;
          background: rgba(212, 168, 87, 0.1);
          border: 1px solid rgba(212, 168, 87, 0.3);
          color: #d4a857;
          border-radius: 999px;
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 1.8px;
          margin-bottom: 10px;
        }
        .gpft-cta-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #d4a857;
          box-shadow: 0 0 8px #d4a857;
          animation: gpft-pulse 1.6s ease-in-out infinite;
        }
        @keyframes gpft-pulse { 0%,100% { opacity:1; transform: scale(1); } 50% { opacity:.55; transform: scale(.85); } }
        .gpft-cta-text h3 {
          font-family: "Playfair Display", "Times New Roman", serif;
          font-size: 26px;
          color: #fff;
          font-weight: 700;
          margin: 0 0 6px;
          line-height: 1.25;
        }
        .gpft-cta-text h3 span {
          background: linear-gradient(135deg, #f1cf85, #b58a3f);
          -webkit-background-clip: text; background-clip: text; color: transparent;
          font-style: italic; font-weight: 600;
        }
        .gpft-cta-text p {
          font-size: 13.5px;
          color: #9aa0a8;
          margin: 0;
          max-width: 560px;
          line-height: 1.55;
        }
        .gpft-cta-actions {
          display: inline-flex;
          gap: 10px;
          flex-shrink: 0;
        }
        .gpft-cta-btn {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 12px 20px;
          border-radius: 11px;
          font-size: 12.5px;
          font-weight: 800;
          letter-spacing: 0.4px;
          text-transform: uppercase;
          text-decoration: none;
          transition: transform .2s ease, box-shadow .25s ease, gap .2s ease;
        }
        .gpft-cta-primary {
          background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
          color: #0b0b0c;
        }
        .gpft-cta-primary:hover {
          color: #0b0b0c; text-decoration: none;
          transform: translateY(-2px);
          box-shadow: 0 14px 30px rgba(212,168,87,0.35);
          gap: 12px;
        }
        .gpft-cta-wa {
          background: linear-gradient(135deg, #25d366, #128c7e);
          color: #fff;
        }
        .gpft-cta-wa:hover {
          color: #fff; text-decoration: none;
          transform: translateY(-2px);
          box-shadow: 0 12px 26px rgba(37,211,102,0.35);
        }

        /* MAIN GRID */
        .gpft-main {
          position: relative;
          max-width: 1200px;
          margin: 0 auto;
          padding: 50px 22px 24px;
          z-index: 1;
        }
        .gpft-grid {
          display: grid;
          grid-template-columns: 1.7fr 1fr 1fr 1fr;
          gap: 36px;
          margin-bottom: 32px;
        }

        /* BRAND COL */
        .gpft-brand-col { min-width: 0; }
        .gpft-brand {
          display: inline-block;
          margin-bottom: 16px;
          text-decoration: none;
        }
        .gpft-brand img {
          height: 56px;
          width: auto;
          object-fit: contain;
        }
        .gpft-brand-text {
          font-family: "Playfair Display", "Times New Roman", serif;
          font-weight: 700;
          font-size: 18px;
          color: #d4a857;
          letter-spacing: 1.5px;
        }
        .gpft-brand-text span {
          display: block;
          font-size: 11px;
          letter-spacing: 4px;
          color: #fff;
        }
        .gpft-brand-blurb {
          font-size: 13.5px;
          color: #9aa0a8;
          line-height: 1.65;
          margin: 0 0 18px;
          max-width: 360px;
        }
        .gpft-info-list {
          display: flex; flex-direction: column;
          gap: 10px;
          margin-bottom: 18px;
        }
        .gpft-info-row {
          display: flex; align-items: flex-start; gap: 10px;
          font-size: 13px;
          color: #b8bcc4;
          line-height: 1.5;
          text-decoration: none;
        }
        .gpft-info-row strong { color: #d4a857; font-weight: 700; }
        .gpft-info-icon {
          width: 26px; height: 26px;
          background: rgba(212, 168, 87, 0.1);
          border: 1px solid rgba(212, 168, 87, 0.25);
          border-radius: 7px;
          color: #d4a857;
          display: inline-flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .gpft-info-link { transition: color .2s ease; }
        .gpft-info-link:hover { color: #d4a857; text-decoration: none; }

        .gpft-trust-row {
          display: flex; flex-wrap: wrap; gap: 6px;
        }
        .gpft-trust-pill {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 4px 10px;
          background: rgba(212, 168, 87, 0.08);
          border: 1px solid rgba(212, 168, 87, 0.22);
          color: #d4a857;
          border-radius: 999px;
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 0.6px;
          text-transform: uppercase;
        }

        /* LINK COLUMNS */
        .gpft-col { min-width: 0; }
        .gpft-col-title {
          font-family: "Playfair Display", "Times New Roman", serif;
          font-size: 15px;
          color: #fff;
          font-weight: 700;
          margin: 0 0 14px;
          padding-bottom: 10px;
          letter-spacing: 0.4px;
          position: relative;
        }
        .gpft-col-title::after {
          content: "";
          position: absolute;
          left: 0; bottom: 0;
          width: 28px; height: 2px;
          background: linear-gradient(90deg, #f1cf85, #b58a3f);
          border-radius: 2px;
        }
        .gpft-link-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex; flex-direction: column; gap: 4px;
        }
        .gpft-link-list li { line-height: 1; }
        .gpft-link-list a {
          display: inline-block;
          padding: 7px 0;
          font-size: 13px;
          color: #9aa0a8;
          text-decoration: none;
          transition: color .2s ease, padding-left .2s ease;
          position: relative;
        }
        .gpft-link-list a::before {
          content: "";
          position: absolute;
          left: 0; top: 50%;
          transform: translateY(-50%) scaleX(0);
          width: 14px; height: 1.5px;
          background: linear-gradient(90deg, #f1cf85, #b58a3f);
          border-radius: 999px;
          transition: transform .2s ease;
          transform-origin: left;
        }
        .gpft-link-list a:hover {
          color: #d4a857;
          padding-left: 18px;
          text-decoration: none;
        }
        .gpft-link-list a:hover::before {
          transform: translateY(-50%) scaleX(1);
        }

        /* DIVIDER ROW */
        .gpft-divider-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 22px;
          padding: 22px 0;
          border-top: 1px dashed rgba(212, 168, 87, 0.22);
          flex-wrap: wrap;
        }

        .gpft-payments, .gpft-social {
          display: flex; align-items: center; gap: 12px;
        }
        .gpft-payments-label, .gpft-social-label {
          font-size: 10.5px;
          color: #6e7480;
          text-transform: uppercase;
          letter-spacing: 1.6px;
          font-weight: 700;
        }
        .gpft-payment-cards {
          display: inline-flex; gap: 6px;
        }
        .gpft-payment-card {
          height: 28px;
          padding: 0 10px;
          display: inline-flex;
          align-items: center;
          gap: 5px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.6px;
        }
        .gpft-pay-visa {
          background: #fff;
          color: #1a1f71;
        }
        .gpft-pay-mc {
          background: #fff;
          padding: 0 8px;
          gap: 0;
        }
        .gpft-mc-1, .gpft-mc-2 {
          width: 14px; height: 14px;
          border-radius: 50%;
        }
        .gpft-mc-1 { background: #eb001b; margin-right: -5px; }
        .gpft-mc-2 { background: #f79e1b; opacity: 0.85; }
        .gpft-pay-secure {
          background: rgba(212,168,87,0.12);
          border: 1px solid rgba(212,168,87,0.32);
          color: #d4a857;
        }

        .gpft-social-icons { display: inline-flex; gap: 6px; }
        .gpft-social-icons a {
          width: 36px; height: 36px;
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(212, 168, 87, 0.22);
          border-radius: 9px;
          color: #d4a857;
          display: inline-flex; align-items: center; justify-content: center;
          transition: background .2s ease, border-color .2s ease, color .2s ease, transform .2s ease;
        }
        .gpft-social-icons a:hover {
          background: rgba(212, 168, 87, 0.16);
          border-color: rgba(212, 168, 87, 0.55);
          color: #f1cf85;
          transform: translateY(-2px);
        }
        .gpft-social-icons .gpft-social-wa:hover {
          background: rgba(37, 211, 102, 0.18);
          border-color: rgba(37, 211, 102, 0.55);
          color: #4ade80;
        }

        /* BOTTOM BAR */
        .gpft-bottom {
          background: rgba(0, 0, 0, 0.35);
          border-top: 1px solid rgba(212, 168, 87, 0.15);
        }
        .gpft-bottom-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 18px 22px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }
        .gpft-copy {
          margin: 0;
          font-size: 12.5px;
          color: #9aa0a8;
        }
        .gpft-copy strong { color: #d4a857; font-weight: 700; }
        .gpft-made {
          margin: 0;
          display: inline-flex; align-items: center; gap: 8px;
          font-size: 12px;
          color: #6e7480;
          letter-spacing: 0.4px;
        }
        .gpft-flag { font-size: 14px; line-height: 1; }

        /* RESPONSIVE */
        @media (max-width: 1100px) {
          .gpft-grid { grid-template-columns: 1.5fr 1fr 1fr 1fr; gap: 28px; }
        }
        @media (max-width: 991px) {
          .gpft-cta-inner { grid-template-columns: 1fr; gap: 18px; }
          .gpft-cta-actions { flex-wrap: wrap; }
          .gpft-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
          .gpft-brand-col { grid-column: 1 / -1; }
        }
        @media (max-width: 720px) {
          .gpft-cta-inner { padding: 28px 18px; }
          .gpft-cta-text h3 { font-size: 22px; }
          .gpft-main { padding: 40px 18px 20px; }
          .gpft-grid { gap: 28px; }
          .gpft-divider-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
          }
          .gpft-payments, .gpft-social { flex-wrap: wrap; }
          .gpft-bottom-inner {
            flex-direction: column;
            text-align: center;
            gap: 8px;
          }
        }
        @media (max-width: 575px) {
          .gpft-cta-actions { width: 100%; }
          .gpft-cta-btn { flex: 1 1 auto; justify-content: center; }
          .gpft-grid { grid-template-columns: 1fr; gap: 26px; }
          .gpft-brand img { height: 48px; }
          .gpft-cta-text h3 { font-size: 20px; }
          .gpft-cta-text p { font-size: 13px; }
          .gpft-payments-label, .gpft-social-label { width: 100%; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
